<div class="flex align-items-center gap-3 mb-3">
  <label class="font-bold">Statut</label>
  <p-dropdown
    [options]="statusOptions"
    [(ngModel)]="statusFilter"
    (onChange)="refresh()"
    styleClass="w-15rem"></p-dropdown>
  <button pButton type="button" icon="pi pi-refresh" class="p-button-outlined" label="Actualiser" (click)="refresh()"></button>
</div>

<p-table [value]="requests" styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm" [loading]="api.loading" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Date</th>
      <th>Client</th>
      <th>Facture</th>
      <th>Produit</th>
      <th>Qté facturée</th>
      <th>Qté demandée</th>
      <th>Raison</th>
      <th>Photo</th>
      <th>Statut</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{row.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
      <td>{{row.CustomerName}}<div class="text-500 text-sm">{{row.CustomerId}}</div></td>
      <td>
        <a target="_blank" href="https://ws.blackrockgames.fr/pdf.php?file={{row.InvoiceDocumentNumber}}">{{row.InvoiceDocumentNumber}}</a>
        <div class="text-500 text-sm" *ngIf="row.OrderReference">Ref. {{row.OrderReference}}</div>
      </td>
      <td>{{row.ItemId}}<div class="text-500 text-sm">{{row.ItemName}}</div></td>
      <td>{{row.qty_initial}}</td>
      <td>{{row.qty_requested}}</td>
      <td style="max-width: 220px; white-space: pre-wrap;">{{row.reason}}</td>
      <td>
        <div class="flex flex-wrap gap-1" *ngIf="photoList(row).length">
          <a *ngFor="let photo of photoList(row)" [href]="photo" target="_blank" rel="noopener">
            <img [src]="photo" alt="photo" style="max-width: 64px; max-height: 48px; object-fit: cover;" />
          </a>
        </div>
      </td>
      <td>
        <p-tag [value]="statusLabel(row.status)" [severity]="statusSeverity(row.status)"></p-tag>
      </td>
      <td>
        <div class="flex gap-2" *ngIf="row.status === 'pending'">
          <button pButton type="button" class="p-button-success p-button-sm" label="Accepter" (click)="openAction(row, 'accepted')"></button>
          <button pButton type="button" class="p-button-danger p-button-sm" label="Refuser" (click)="openAction(row, 'refused')"></button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10" class="text-center p-4">Aucune demande d'avoir</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="displayAction"
  [modal]="true"
  [style]="{width: '640px'}"
  [header]="actionType === 'accepted' ? 'Accepter la demande' : 'Refuser la demande'"
  [closable]="!saving">
  <div *ngIf="selectedRequest" class="flex flex-column gap-3">
    <p class="m-0">
      {{selectedRequest.CustomerName}} — {{selectedRequest.ItemId}} — qté {{selectedRequest.qty_requested}}
    </p>
    <div>
      <label class="font-bold block mb-2">Commentaire (optionnel)</label>
      <textarea
        pInputTextarea
        [(ngModel)]="adminComment"
        rows="4"
        class="w-full"></textarea>
    </div>
    <div>
      <p-checkbox
        [(ngModel)]="notifyClient"
        [binary]="true"
        inputId="notifyClient"
        (onChange)="onNotifyChange()"></p-checkbox>
      <label for="notifyClient" class="ml-2">Notifier le client par mail</label>
    </div>
    <div *ngIf="notifyClient && actionType === 'refused'" class="flex flex-column gap-2">
      <p-message severity="info" text="Vous pouvez modifier le contenu de l'email de refus avant envoi." styleClass="w-full"></p-message>
      <div>
        <label class="font-bold block mb-2">Objet de l'email</label>
        <input type="text" pInputText class="w-full" [(ngModel)]="clientMailSubject" />
      </div>
      <div>
        <label class="font-bold block mb-2">Contenu de l'email</label>
        <textarea pInputTextarea [(ngModel)]="clientMailBody" rows="10" class="w-full"></textarea>
      </div>
    </div>
    <p-message
      *ngIf="notifyClient && actionType === 'accepted'"
      severity="info"
      text="Un email d'acceptation sera envoyé au client avec votre commentaire."
      styleClass="w-full"></p-message>
    <p-message
      *ngIf="actionType === 'accepted'"
      severity="warn"
      text="Un email sera également envoyé à ADV (adv@blackrockgames.fr)."
      styleClass="w-full"></p-message>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" pButton class="p-button-text" label="Annuler" [disabled]="saving" (click)="displayAction = false"></button>
    <button
      type="button"
      pButton
      [label]="actionType === 'accepted' ? 'Accepter' : 'Refuser'"
      [class]="actionType === 'accepted' ? 'p-button-success' : 'p-button-danger'"
      [disabled]="saving"
      (click)="confirmAction()"></button>
  </ng-template>
</p-dialog>
